/* Product gallery, delivery display, size guide and custom-price calculator.
   Custom prices use the ERP Shopify selling rate; only the final USD price is displayed. */
(function () {
  // —— GALLERY ——
  // One index owns the state. Arrows, keyboard, swipe and thumbnail clicks all move that
  // index; images and videos are already rendered by Liquid so changing media never rewrites URLs.
  var gal = document.querySelector('[data-gal]');
  if (gal) {
    var slides = [].slice.call(gal.querySelectorAll('[data-media-slide]'));
    var gallery = gal.closest('.pdp__gallery');
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-media-thumb]'));
    var zoom = gallery.querySelector('[data-gallery-zoom]');
    var zoomImage = gallery.querySelector('[data-zoom-image]');
    var idx = 0;
    var countEl = gal.querySelector('[data-gal-count]');
    gallery.addEventListener('contextmenu', function (event) {
      if (event.target.closest('[data-gallery-zoom], [data-media-slide]')) event.preventDefault();
    });
    gallery.addEventListener('dragstart', function (event) {
      if (event.target.closest('[data-gallery-zoom], [data-media-slide]')) event.preventDefault();
    });
    gallery.querySelectorAll('[data-media-slide] video').forEach(function (video) {
      var play = video.parentElement.querySelector('[data-video-play]');
      if (!play) return;
      play.addEventListener('click', function () {
        video.play().catch(function () { play.hidden = false; });
      });
      video.addEventListener('play', function () { play.hidden = true; });
      video.addEventListener('pause', function () { play.hidden = false; });
      video.addEventListener('ended', function () { play.hidden = false; });
    });


    function show(i, focusThumb) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        slide.hidden = n !== idx;
        if (n !== idx) [].slice.call(slide.querySelectorAll('video')).forEach(function (video) { video.pause(); });
      });
      if (countEl) countEl.textContent = (idx + 1) + ' / ' + slides.length;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('on', n === idx);
        t.setAttribute('aria-pressed', n === idx ? 'true' : 'false');
      });
      if (focusThumb && thumbs[idx] && thumbs[idx].scrollIntoView) {
        thumbs[idx].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    gal.addEventListener('click', function (ev) {
      var enlarge = ev.target.closest('[data-gallery-enlarge]');
      if (enlarge && zoom && zoomImage) {
        var source = slides[idx].querySelector('img');
        if (source) { zoomImage.src = source.src; zoomImage.alt = source.alt; zoom.showModal(); }
      }
      if (ev.target.closest('[data-gal-prev]')) { ev.preventDefault(); show(idx - 1, true); }
      if (ev.target.closest('[data-gal-next]')) { ev.preventDefault(); show(idx + 1, true); }
    });

    document.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-media-thumb]');
      if (!t) return;
      var n = thumbs.indexOf(t);
      if (n > -1) show(n, false);
    });

    // Arrow keys, but never while the shopper is typing in a field.
    gallery.addEventListener('keydown', function (ev) {
      if (slides.length < 2 || (zoom && zoom.open)) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
      if (ev.key === 'ArrowLeft') { ev.preventDefault(); show(idx - 1, true); }
      if (ev.key === 'ArrowRight') { ev.preventDefault(); show(idx + 1, true); }
    });

    // Swipe. Horizontal intent only, so a vertical page scroll is never hijacked.
    var sx = 0, sy = 0, tracking = false;
    gal.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1), true);
    }, { passive: true });

    show(0, false);
  }

  // —— sticky mobile add-to-cart mirrors the real form ——
  var matc = document.querySelector('[data-matc]');
  if (matc) {
    matc.addEventListener('click', function () {
      var f = document.querySelector('form[data-product-form]');
      if (!f || matc.disabled) return;
      var submit = f.querySelector('[type=submit]');
      if (submit && submit.disabled) return;
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
    });
  }
  var sel = document.querySelector('[data-variant-select]');
  var sampleShortcut = document.querySelector('[data-select-swatch]');
  if (sampleShortcut && sel) sampleShortcut.addEventListener('click', function () {
    sel.value = sampleShortcut.getAttribute('data-select-swatch');
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    var add = document.querySelector('form[data-product-form] [type=submit]');
    if (add) add.focus();
  });
  var mp = document.querySelector('[data-matc-price]');
  if (sel && mp) {
    sel.addEventListener('change', function () {
      setTimeout(function () {
        var main = document.querySelector('[data-price]');
        if (main) mp.textContent = main.textContent;
      }, 0);
    });
  }

  var etaEl = document.querySelector('[data-eta]');
  if (etaEl) {
    var etaMode = etaEl.getAttribute('data-mode') || 'MTO_ONLY';
    var vdata = {};
    try { vdata = JSON.parse(sel ? sel.getAttribute('data-variants') : '{}'); } catch {}
    var updateFulfilment = function () {
      var variant = sel ? vdata[sel.value] : null;
      var ready = etaMode !== 'MTO_ONLY' && (variant ? variant.available && variant.qty > 0 : etaEl.getAttribute('data-instock') === '1');
      var unavailable = (variant ? !variant.available : etaEl.getAttribute('data-available') === 'false') || (etaMode === 'STOCK_ONLY' && !ready);
      var dispatch = window.IndiaLivingSizes.dispatchRange(new Date(), ready, document.documentElement.lang);
      var status = unavailable ? 'Unavailable in this size' : (ready ? 'Ready to ship' : 'Woven to order') + ' · estimated dispatch ' + dispatch;
      var line = document.querySelector('[data-avail]');
      if (line) line.textContent = status;
      etaEl.hidden = true;
      etaEl.textContent = '';
      var craftIcon = document.querySelector('.pdp__craft-icon');
      if (craftIcon) craftIcon.hidden = !!unavailable || !!ready;
      var submit = document.querySelector('form[data-product-form] [type=submit]');
      [submit, matc].forEach(function (button) {
        if (button) { button.disabled = !!unavailable; button.textContent = unavailable ? 'Unavailable' : 'Add to cart'; }
      });
      var tile = document.querySelector('[data-fulfilment-tile]');
      if (tile) {
        tile.querySelector('b').textContent = unavailable ? 'Currently unavailable' : ready ? 'Ready to ship' : 'Woven to order';
        tile.querySelector('span').textContent = unavailable ? 'Choose another size' : 'Estimated dispatch ' + dispatch;
      }
    };
    updateFulfilment();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) updateFulfilment(); });
    setInterval(updateFulfilment, 60000);
    if (sel) sel.addEventListener('change', function () { setTimeout(updateFulfilment, 0); });
  }

  // —— size-guide dialog ——
  var sg = document.querySelector('[data-sizeguide]');
  if (sg) {
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-open-sizeguide]') && sg.showModal) sg.showModal();
      if (ev.target.closest('[data-close-sizeguide]')) sg.close();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' && ev.target.closest && ev.target.closest('[data-open-sizeguide]') && sg.showModal) sg.showModal();
    });
    sg.addEventListener('click', function (e) { if (e.target === sg) sg.close(); });
  }

  var range = document.querySelector('[data-size-range]');
  var sizeEngine = window.IndiaLivingSizes;
  if (range && sel && sizeEngine) {
    var dimensions = [].slice.call(sel.options).map(function (option) {
      return sizeEngine.parse(option.getAttribute('data-title') || option.textContent);
    }).filter(function (size) { return Number.isFinite(size.area) && size.area > 0; });
    var groups = sizeEngine.groups.map(function (group) {
      var sizes = dimensions.filter(function (size) { return size.group === group; }).sort(sizeEngine.compare);
      if (!sizes.length) return '';
      var first = sizeEngine.label(sizes[0]).split(' (')[0];
      var last = sizeEngine.label(sizes[sizes.length - 1]).split(' (')[0];
      return group + ': ' + first + (last !== first ? ' – ' + last : '');
    }).filter(Boolean);
    if (groups.length) {
      range.replaceChildren();
      groups.forEach(function (label) { var row = document.createElement('span'); row.textContent = label; range.appendChild(row); });
    }
  }
  var header = document.querySelector('.hdr');
  if (header && window.ResizeObserver) {
    new ResizeObserver(function () {
      document.documentElement.style.setProperty('--gallery-top', Math.ceil(header.getBoundingClientRect().height + 16) + 'px');
    }).observe(header);
  }
  document.querySelectorAll('.pdp__description h2, .pdp__description h3, .pdp__description h4').forEach(function (heading) {
    if (!/^(choose your size|sizes?|available sizes|size options|dimensions)$/i.test(heading.textContent.trim())) return;
    var next = heading.nextElementSibling;
    while (next && !/^H[1-6]$/.test(next.tagName)) {
      var following = next.nextElementSibling;
      next.remove(); next = following;
    }
    heading.remove();
  });

  var calc = document.querySelector('[data-calc]');
  if (!calc || !window.IndiaLivingSizes) return;
  var engine = window.IndiaLivingSizes;
  var variants = JSON.parse(calc.querySelector('[data-calc-variants]').textContent);
  var text = JSON.parse(calc.querySelector('[data-calc-text]').textContent);
  var rate = Number(calc.getAttribute('data-rate'));
  var courierBands = [];
  try { courierBands = JSON.parse(calc.getAttribute('data-courier-bands') || '[]'); } catch {}

  var unitSel = calc.querySelector('[data-calc-unit]');
  var shapeSel = calc.querySelector('[data-calc-shape]');
  var width = calc.querySelector('[data-calc-w]'), widthIn = calc.querySelector('[data-calc-w-in]');
  var length = calc.querySelector('[data-calc-l]'), lengthIn = calc.querySelector('[data-calc-l-in]');
  var lengthWrap = calc.querySelector('[data-calc-len]');
  var price = calc.querySelector('[data-calc-price]'), note = calc.querySelector('[data-calc-note]');
  var unit = 'ft';
  var groupNames = { rect:'Rectangular', square:'Square', round:'Round', runner:'Runner' };
  var offered = variants.map(function(v){return engine.parse(v.title).group;});
  // Only offer shapes actually sold for this product. Never assume a flatweave can be cut round.
  [].slice.call(shapeSel.options).forEach(function(o){ if(offered.some(function(g){return ['Rectangular','Square','Round','Runner'].indexOf(g)>=0;}) ? offered.indexOf(groupNames[o.value])<0 : o.value!=='rect') o.remove(); });
  function feet(main, inches) {
    if (main.value === '') return null;
    var n=Number(main.value), i=Number(inches.value || 0);
    if(!Number.isFinite(n) || !Number.isFinite(i) || n<0 || i<0 || i>=12) return null;
    var value=unit === 'cm' ? n/30.48 : n+i/12;
    return value>=1 ? value : null;
  }
  function compute() {
    var equal=shapeSel.value === 'round' || shapeSel.value === 'square';
    lengthWrap.hidden=equal;
    var w=feet(width,widthIn), l=equal ? w : feet(length,lengthIn);
    price.textContent=''; note.textContent='';
    var contact = calc.querySelector('[data-calc-contact]');
    contact.hidden = true;
    if(w===null || l===null || !shapeSel.value){ note.textContent=text.invalid; return; }
    var amount=engine.customPrice(rate,groupNames[shapeSel.value],w,l,courierBands);
    if(amount===null || !Number.isFinite(amount) || amount<=0) note.textContent=text.unpriced;
    else {
      price.textContent=new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:'USD'}).format(amount/100);
      note.textContent=text.estimate;
    }
    var widthLabel = unit === 'cm' ? width.value + ' cm' : width.value + ' ft ' + (widthIn.value || '0') + ' in';
    var lengthLabel = unit === 'cm' ? length.value + ' cm' : length.value + ' ft ' + (lengthIn.value || '0') + ' in';
    var dimensions = shapeSel.value === 'round' ? widthLabel + ' diameter' : widthLabel + ' × ' + (equal ? widthLabel : lengthLabel);
    var message = engine.enquiry(calc.getAttribute('data-product-title'),calc.getAttribute('data-product-url'),groupNames[shapeSel.value],dimensions,price.textContent);
    // Reuse the storefront's existing WhatsApp sharing destination; no recipient is invented.
    var existing = document.querySelector('a[href*="wa.me/"]');
    var whatsapp = new URL(existing ? existing.href : 'https://wa.me/');
    whatsapp.searchParams.set('text',message);
    calc.querySelector('[data-calc-whatsapp]').href=whatsapp.toString();
    calc.querySelector('[data-calc-email]').href='mailto:' + calc.getAttribute('data-contact-email') + '?subject=' + encodeURIComponent('Custom-size enquiry — ' + calc.getAttribute('data-product-title')) + '&body=' + encodeURIComponent(message);
    contact.hidden=false;
  }
  unitSel.addEventListener('change',function(){
    var next=unitSel.value;
    if(next===unit) return;
    [[width,widthIn],[length,lengthIn]].forEach(function(pair,index){
      var value=feet(pair[0],pair[1]);
      if(value!==null){
        if(next==='cm') pair[0].value=(value*30.48).toFixed(2);
        else { var inches=Math.round(value*12); pair[0].value=Math.floor(inches/12); pair[1].value=inches%12; }
      }
      pair[0].step=next==='cm'?'0.01':'1';

      pair[1].parentElement.style.display=next==='cm'?'none':'';
      pair[0].setAttribute('aria-label',(index===0?'Width':'Length')+(next==='cm'?', centimetres':', whole feet'));
      var suffix=calc.querySelector(index===0?'[data-calc-w-suffix]':'[data-calc-l-suffix]'); suffix.textContent=next==='cm'?'cm':'ft';
    });
    unit=next; compute();
  });
  [width,widthIn,length,lengthIn,shapeSel].forEach(function(el){el.addEventListener('input',compute);});
  compute();
})();
